import React from "react";
import { View, StyleSheet, Text, Platform, FlatList } from "react-native";

import AppTheme from "../../AppTheme";
import Dialog from "../../common/dialog";
import ManaButton from "../../common/ManaButton";
import ThrowToTrashIcon from "../../common/icons/integrations/ThrowToTrashIcon";
import { hasItems } from "../../../../helpers/utils";
import IntegrationWrapper from "../details/IntegrationWrapper";
import { MoodColors } from "../../common/mood/MoodsHelper";

export default function DeleteRuleConfirmDialog({
  controller,
  data = [],
  entity = "instance",
  confirm = () => {},
  cancel = () => {},
  ignore = () => {},
}) {
  const description =
    "We’ll delete" +
    (hasItems(data) && data.length == 1
      ? ` this ${entity} `
      : ` these ${entity}s `) +
    "from your account. If you don’t want to see similar data here again, tap “Ignore Data Like This” below.";

  return (
    <Dialog.Container
      onClose={cancel}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 8,
        paddingBottom: 12,
        minHeight: 360,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>Are you sure?</Text>
        {hasItems(data) ? (
          <FlatList
            style={{
              width: "100%",
              maxHeight: 200,
              paddingHorizontal: 0,
              flexGrow: 0,
            }}
            data={data}
            keyExtractor={(item) => item.id}
            renderItem={({ item }) => (
              <IntegrationWrapper
                controller={controller}
                data={item}
                style={{
                  marginBottom: 0,
                  paddingVertical: 4,
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              />
            )}
          />
        ) : null}

        <Text style={styles.description}>{description}</Text>
      </View>

      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ThrowToTrashIcon style={styles.imageBg} />
      </View>

      <View style={[styles.buttons, { marginTop: 26 }]}>
        <ManaButton
          style={[styles.button, { marginRight: 6 }]}
          styleText={styles.buttonText}
          text="Cancel"
          onPress={cancel}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Confirm"
          onPress={confirm}
        />
      </View>
      <Text style={styles.ignoreText} onPress={ignore}>
        Ignore Data Like This
      </Text>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  imageBg: {
    marginTop: 16,
  },
  ignoreText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    textAlign: "center",
    marginTop: 13,
  },
});
